import React from "react"

import { Switch as MuiSwitch } from "@mui/material"
import { styled } from "@mui/material/styles"
import T from "prop-types"

const StyledWrapper = styled("div")(({ fullWidth, theme: { typography } }) => ({
  alignItems: "center",
  display: "flex",
  fontSize: typography.pxToRem(14),
  justifyContent: "space-between",
  width: fullWidth ? "100%" : "auto",
}))

export const LabeledSwitch = ({ fullWidth, label, secondLabel, ...props }) => (
  <StyledWrapper fullWidth={fullWidth}>
    {label && label}
    <MuiSwitch color="primary" {...props} />
    {secondLabel && secondLabel}
  </StyledWrapper>
)

LabeledSwitch.propTypes = {
  fullWidth: T.bool,
  label: T.string,
  secondLabel: T.string,
}
